import { render, staticRenderFns } from "./acessos.vue?vue&type=template&id=3a62d6fc&"
import script from "./acessos.vue?vue&type=script&lang=ts&"
export * from "./acessos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports